import React from 'react';

export default function IcArrow({ direction }) {

  let _direction = direction === "right"
    ? "rotate(180deg"
    : direction === "top"
      ? "rotate(90deg)"
      : direction === "bottom"
        ? "rotate(270deg)"
        : ""
  return (
    <>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 377.4 560" width="10px" style={{ transform: _direction }}>
        <g>
          <path class="st0" d="M0,280l377.4,280V0L0,280z" />
        </g>
      </svg>
    </>
  );
}
